var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPropeller = function SvgPropeller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94 11.27c-.96-.355-2.565-.581-4.103.29-2.596 1.451-5.063-.774-4.71-3.23.32-2.162 1.665-4.392 3.331-5.293 2.53-1.324 4.455-.582 5.928 1.034.96 1.066 1.987 2.94 2.084 4.712.03.84.991.808 1.25.13.353-.969.578-2.585-.286-4.135-1.445-2.613.767-5.099 3.204-4.744 2.146.32 4.354 1.644 5.253 3.358 1.314 2.549.578 4.49-1.026 5.972-1.058.969-2.917 2.003-4.676 2.1-.834.032-.802 1-.128 1.262.96.355 2.564.581 4.102-.29 2.596-1.451 5.064.775 4.711 3.23-.321 2.163-1.635 4.392-3.331 5.294-2.53 1.324-4.455.582-5.928-1.034-.96-1.067-1.987-2.94-2.084-4.713-.031-.84-.992-.808-1.251-.129-.353.969-.577 2.585.286 4.135 1.442 2.615-.767 5.103-3.204 4.747-2.146-.324-4.358-1.647-5.253-3.357-1.313-2.55-.577-4.49 1.027-5.973 1.057-.969 2.917-2.003 4.676-2.1.802-.071.771-1.04.128-1.266zm3.045 1.968a1.22 1.22 0 0 0 1.216-1.226 1.221 1.221 0 0 0-1.216-1.226c-.674 0-1.216.55-1.216 1.226a1.218 1.218 0 0 0 1.216 1.226z",
    fill: "#004152"
  })));
};

export default SvgPropeller;